var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{class:_vm.$options.methods.getClasses(_vm.props),domProps:{"textContent":_vm._s(_vm.$options.methods.getLabelText(_vm.props))}})}
var staticRenderFns = []

export { render, staticRenderFns }